import { render, staticRenderFns } from "./DeadsCPLotes.vue?vue&type=template&id=59446cc2"
import script from "./DeadsCPLotes.vue?vue&type=script&lang=js"
export * from "./DeadsCPLotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports